import React, { useContext, useEffect } from 'react';
import { Navigate, useOutlet } from 'react-router-dom';
import styled from 'styled-components';
import AsyncLocalStorage from '../utils/AsyncLocalStorage';
import { AuthContext } from '../navigation/TemporaryUserInfo';
import LoginController from '../controller/LoginController';

export const ProtectedLayout = (oProps: any) => {
  const { logout } = useContext(AuthContext);
  const { user } = useContext(AuthContext) || {};
  const outlet = useOutlet();
  const verifyAuthToken = async () => {
    try {
      let oRes = await LoginController.verifyAuthToken();

      if (oRes.data && oRes.data.ok) {
        console.log('verifyAuthToken 가져오기 성공');
      } else {
        if (oRes.data.msg === 'VERIFY_ERROR') {
          console.log('VERIFY_ERROR');
          alert('토큰정보가 만료되었습니다. 다시 로그인해주세요.');
          logout();
        }
      }
    } catch (error) {
      console.error('Login error:', error);
      logout();
    }
  };
  useEffect(() => {
    verifyAuthToken();
  }, []);

  if (user) {
    return (
      <MainStyle>
        <div>
          <div className="screen">
            <div>{outlet}</div>
          </div>
        </div>
      </MainStyle>
    );
  }

  return <Navigate to="/login" />;
};

export const MainStyle = styled.div`
  /* 공통 */
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p,
  a,
  button,
  input,
  textarea {
    padding: 0;
    color: #000;
    font-family: 'pretendard';
  }
  input,
  textarea,
  button {
    cursor: pointer;
  }
  a {
    text-decoration: none;
  }

  .wrapper {
    width: 100%;
    height: 100vh;
  }

  .flexSpaceBetween {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .flexStart {
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }
`;
